import { Origin } from "../utils/UrlUtils";
function postMessage(message) {
    const data = {
        message: message,
    };
    window.postMessage(JSON.stringify(data), Origin);
}
export default postMessage;
